/** Limits applied before anything is sent; the database and the storage bucket enforce them again. */
export interface DepositLimits {
  /** Instagram carousels hold at most 20 slides. */
  maxSlides: number;
  /** Largest stored file (the storage bucket limit: 50 MB on Supabase Free). */
  maxFileBytes: number;
  /** ZIP safety: entries read and total size once decompressed. */
  maxZipEntries: number;
  maxZipUncompressedBytes: number;
  maxNoteChars: number;
}

export const DEFAULT_LIMITS: DepositLimits = {
  maxSlides: 20,
  maxFileBytes: 50 * 1024 * 1024,
  maxZipEntries: 500,
  maxZipUncompressedBytes: 400 * 1024 * 1024,
  maxNoteChars: 2000,
};

/** A refusal shown to the person depositing, in French, with every reason. */
export class DepositError extends Error {
  constructor(
    message: string,
    readonly issues: string[] = [],
  ) {
    super(message);
    this.name = "DepositError";
  }
}
